import { optionalI18nString } from '@/services/dataStore/queries/fragments'

export const tutorialCopyQuery = () =>
  `{
    'tours': *[_type == "tutorial"] {
      tourId,
      ${optionalI18nString('pickerTitle')},
      ${optionalI18nString('pickerDescription')},
      ${optionalI18nString('finaleTitle')},
      ${optionalI18nString('finaleBody')}
    },
    'steps': *[_type == "tutorialStep"] {
      stepId,
      ${optionalI18nString('title')},
      ${optionalI18nString('body')},
      ${optionalI18nString('actionHint')},
      ${optionalI18nString('manualLabel')}
    }
  }`
